// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"29":"chunk_admin-permissions","47":"chunk_mydata","99":"chunk_publisher2","245":"chunk_admin-users","350":"chunk_printout","385":"chunk_featuredata","682":"chunk_admin","749":"chunk_appsetup","857":"chunk_admin-layereditor","893":"chunk_admin-announcements","974":"chunk_admin-layeranalytics"}[chunkId] + "/oskari.min.js";
};